import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { InputNumber } from "antd";
const CurrencyInput = ({ value = null, onChange, style, disabled = false, onBlur, min = 0, max, step = 1, precision = 2 }) => {
    return (_jsx(InputNumber, { value: value, onChange: onChange, prefix: "$", style: style, onBlur: onBlur, disabled: disabled, min: min, max: max, step: step, precision: precision }));
};
export default CurrencyInput;
